/**
 * Fase 18 · Helpers compartidos para pantallas regulatorias.
 */
export const fmtMXN = (v) => {
    if (v === null || v === undefined || v === "") return "—";
    return new Intl.NumberFormat("es-MX", {
        style: "currency", currency: "MXN", maximumFractionDigits: 2,
    }).format(Number(v));
};

export const fmtPct = (v, decimals = 2) => {
    if (v === null || v === undefined || v === "") return "—";
    return `${(Number(v) * 100).toFixed(decimals)}%`;
};

export const fmtFecha = (iso) => {
    if (!iso) return "—";
    try { return new Date(iso).toLocaleDateString("es-MX"); } catch { return iso; }
};

export const fmtFechaHora = (iso) => {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString("es-MX", {
            dateStyle: "short", timeStyle: "short",
        });
    } catch { return iso; }
};

export const EC_ESTADOS = {
    generado: { label: "Generado", cls: "bg-sky-100 text-sky-900 border-sky-300 border" },
    entregado: { label: "Entregado", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    observado: { label: "Observado", cls: "bg-amber-100 text-amber-900 border-amber-300 border" },
    anulado: { label: "Anulado", cls: "bg-slate-200 text-slate-700 border-slate-300 border" },
};

export const AC_ESTADOS = {
    activo: { label: "Activo", cls: "bg-sky-100 text-sky-900 border-sky-300 border" },
    en_expurgo: { label: "En expurgo", cls: "bg-amber-100 text-amber-900 border-amber-300 border" },
    expurgado: { label: "Expurgado", cls: "bg-slate-200 text-slate-700 border-slate-300 border" },
};

export const BCP_ESTADOS = {
    planeada: { label: "Planeada", cls: "bg-slate-100 text-slate-800 border-slate-200 border" },
    en_ejecucion: { label: "En ejecución", cls: "bg-sky-100 text-sky-900 border-sky-300 border" },
    cerrada: { label: "Cerrada", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    observada: { label: "Observada", cls: "bg-amber-100 text-amber-900 border-amber-300 border" },
};

export const INV_ESTADOS = {
    vigente: { label: "Vigente", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    vencida: { label: "Vencida", cls: "bg-amber-100 text-amber-900 border-amber-300 border" },
    liquidada: { label: "Liquidada", cls: "bg-slate-200 text-slate-700 border-slate-300 border" },
    cancelada: { label: "Cancelada", cls: "bg-red-100 text-red-900 border-red-300 border" },
};

export const INSTRUMENTO_LABEL = {
    cete: "CETE", bono_m: "Bono M", udibono: "UDIBONO",
    pagare_bancario: "Pagaré bancario", mesa_dinero: "Mesa de dinero",
    reporto: "Reporto", fondo_inversion: "Fondo de inversión",
    otros: "Otros",
};

export const REGIMEN_LABEL = {
    pactado_fideicomiso: "Pactado en el fideicomiso",
    supletorio_prudencial: "Supletorio prudencial (gubernamental ≤180d)",
};

export const FUENTE_RET_LABEL = {
    rendimientos_inversion: "Rendimientos de inversión",
    intereses: "Intereses",
    arrendamiento: "Arrendamiento",
    otros: "Otros",
};
